var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noApp"},[_c('h1',[_vm._v(_vm._s(_vm.$t('messages.sharedTexts.unsupportedBrowserTitle')))]),_c('p',[_vm._v(_vm._s(_vm.$t('messages.sharedTexts.unsupportedBrowserText')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }